import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { UserDetailedDto, UserRoleMiniDto, UsersClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { LinkMailtoSharedComponent } from '@unity/shared/presentation/link-mailto-shared/link-mailto-shared.component';
import { SortConfig } from '@unity/utils/types';
import { concatMap, from, map, mergeMap, of, toArray } from 'rxjs';

@Component({
  selector: 'unity-grid-user-internal-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    GridSharedComponent,
    LinkGridcellSharedComponent,
    LinkMailtoSharedComponent,
    ChipWorkflowStateSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-user-internal-shared.component.html',
  styleUrl: './grid-user-internal-shared.component.scss',
})
export class GridUserInternalSharedComponent extends AbstractGridComponent<UserDetailedDto> {
  private readonly usersClient = inject(UsersClient);

  protected resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      return query ? { query } : undefined;
    },
    stream: ({ params: { query } }) =>
      this.usersClient.getAllAsDetailed(query.page, query.pageSize, query.orderBy, query.filter).pipe(
        mergeMap(users =>
          from(users.data).pipe(
            concatMap(user =>
              user.role_membership_users.length > 0
                ? from(user.role_membership_users).pipe(map(role => ({ ...user, role })))
                : of({ ...user, role: {} as UserRoleMiniDto })
            ),
            toArray(),
            map(res => ({ count: res.length, data: res }))
          )
        )
      ),
  });

  protected defaultSort: SortConfig[] = [
    {
      field: 'full_name',
      dir: 'asc',
    },
  ];
}
